import axios from "axios";
import { showErrorMessages } from "../state/app/appActions";
import { doLogout } from "../state/auth/authActions";
import consts from "./consts";

export const axiosPost = async (action, variables, dispatch, extraHeaders) => {
	return await axios({
		method: "post",
		url: `${consts.API_URL}${action}`,
		data: variables,
		withCredentials: false,
		crossDomain: true,
		headers: {
			"Content-Type": "application/json;charset=UTF-8",
			...extraHeaders,
		},
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

export const axiosPatch = async (action, variables, dispatch, extraHeaders) => {
	return await axios({
		method: "patch",
		url: `${consts.API_URL}${action}`,
		data: variables,
		withCredentials: false,
		crossDomain: true,
		headers: {
			"Content-Type": "application/json;charset=UTF-8",
			...extraHeaders,
		},
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

export const axiosPut = async (action, variables, dispatch, extraHeaders) => {
	console.log(`${consts.API_URL}${action}`);
	return await axios({
		method: "put",
		url: `${consts.API_URL}${action}`,
		data: variables,
		withCredentials: false,
		crossDomain: true,
		headers: {
			"Content-Type": "application/json;charset=UTF-8",
			...extraHeaders,
		},
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

export const axiosDelete = async (
	action,
	variables,
	dispatch,
	extraHeaders,
) => {
	return await axios({
		method: "delete",
		url: `${consts.API_URL}${action}`,
		data: variables,
		withCredentials: false,
		crossDomain: true,
		headers: {
			"Content-Type": "application/json;charset=UTF-8",
			...extraHeaders,
		},
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

export const axiosGet = async (
	action,
	params,
	dispatch = () => "sem dispatch",
	extraHeaders = {},
	withCredentials = false,
) => {
	return await axios({
		method: "get",
		url: `${consts.API_URL}${action}`,
		params: { ...params },
		withCredentials: withCredentials,
		crossDomain: true,
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

export const axiosPostBlob = async (action, variables, dispatch) => {
	return await axios({
		method: "post",
		url: `${consts.API_URL}${action}`,
		data: variables,
		responseType: "blob",
		withCredentials: false,
		crossDomain: true,
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

export const axiosLogs = axios.create({
	baseURL: `${consts.MAESTRO_LOGS_URL}`,
	timeout: 10000,
	headers: { Authorization: `Bearer ${localStorage.getItem("apptoken")}` },
});

const replaceAllPrefixoCodigoEntrega = (codigoEntrega) => {
	const replaces = ["LOJAS_AMERICANAS", "SUBMARINO", "SHOPTIME", "-"];
	replaces.forEach((str) => {
		const regex = new RegExp(str, "g");
		codigoEntrega = codigoEntrega.replace(regex, "");
	});
	return codigoEntrega;
};

const axiosAme = axios.create({
	baseURL: `${consts.AME_INTEGRADOR_URL}`,
	timeout: 10000,
	headers: { Authorization: `Bearer ${consts.AME_INTEGRADOR_TOKEN}` },
});

export const axiosGetIntregadorAme = async (
	codigoEntrega,
	dispatch = () => "sem dispatch",
	extraHeaders = {},
	withCredentials = false,
) => {
	const codigo = replaceAllPrefixoCodigoEntrega(codigoEntrega);

	return await axiosAme({
		method: "get",
		url: `/voe-back/entregador/obterResumoEntregadorPorEntrega/${codigo}?trazerSelfieBase64=true`,
		withCredentials: true,
		crossDomain: true,
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

const axiosAuth = axios.create({
	baseURL: `${consts.API_AUTH_URL}`,
	timeout: 10000,
});

export const axiosAuthGet = async (
	action,
	params,
	dispatch = () => "sem dispatch",
	extraHeaders = {},
	withCredentials = false,
) => {
	return await axiosAuth({
		method: "get",
		url: `${action}`,
		params: { ...params },
		withCredentials: withCredentials,
		crossDomain: true,
	}).catch((error) => {
		console.log("error.response -> ", error.response);
		handleErrors(error.response, dispatch);
		return error.response;
	});
};

const handleErrors = (response, dispatch) => {
	let errorMessage = "";
	console.log("===> handleErrors", response);
	if (!response) {
		errorMessage = "Service unavailable!";
		dispatch(showErrorMessages([{ message: errorMessage }]));
	} else if (response.data && response.data.status === 426) {
		window.location.href =
			response.data.storeVersion === "v1"
				? "/"
				: `/${response.data.storeVersion}/all-orders`;
		console.log("===> redirect", response);
		dispatch(
			showErrorMessages([{ message: "Atualizando a Versão do Maestro" }]),
		);
	} else if (response.data && response.data.status === 418) {
		window.location.href = `${consts.CONTEXT}/maintenance`;
	} else if (response.data && response.data.errors) {
		errorMessage = response.data.errors[0].message;
		if (errorMessage.includes("jwt expired")) {
			dispatch(showErrorMessages([{ message: "Acesso expirado!" }]));
			dispatch(doLogout());
		} else {
			dispatch(showErrorMessages(response.data.errors));
		}
	}
};

export const confirmAuthorization = async (params) => {
	const { data } = await axiosAuth.post("/ropc", params);

	return data;
};
